import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FEATURES } from "../mock";

const FeatureCards = () => {
  return (
    <section className="relative z-10 mx-auto max-w-6xl px-4 py-12 md:px-8 md:py-16">
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {FEATURES.map((f) => (
          <div
            key={f.title}
            className="group flex flex-col overflow-hidden rounded-md border border-white/10 bg-[#2a2a2a] shadow-xl transition-transform duration-300 hover:-translate-y-1 hover:shadow-2xl"
          >
            <div className="overflow-hidden">
              {f.image2 ? (
                <div className="flex h-48 items-center justify-center gap-3 bg-[#1c1c1c] py-2" data-testid="feature-card-dual-images">
                  {[f.image, f.image2].map((src, i) => (
                    <img
                      key={src}
                      src={src}
                      alt={i ? f.image2Alt : f.title}
                      className="h-full w-auto max-w-[48%] object-contain shadow-lg transition-transform duration-700 ease-out group-hover:scale-105"
                    />
                  ))}
                </div>
              ) : (
              <img
                src={f.image}
                alt={f.title}
                className="h-48 w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              )}
            </div>
            <div className="flex flex-1 flex-col p-6 text-center">
              <h3 className="font-display text-2xl font-600 uppercase tracking-wide text-[#f2f2f2]">
                {f.title}
              </h3>
              <p className="mt-1 font-display text-base font-500 uppercase tracking-wide text-[#e0a82e]">
                {f.subtitle}
              </p>
              {f.tagline && (
                <p data-testid="feature-card-tagline" className="mt-1 font-display text-sm font-600 uppercase tracking-wide text-[#e0574c]">
                  {f.tagline}
                </p>
              )}
              <p className="mt-4 flex-1 text-sm leading-relaxed text-[#c0c0c0]">
                {f.description}
              </p>
              <Link
                to={f.to}
                className="mx-auto mt-6 inline-flex items-center gap-2 rounded bg-[#e0a82e] px-5 py-2.5 font-display text-sm font-600 uppercase tracking-wide text-[#1c1c1c] transition-colors duration-200 hover:bg-[#f2b93f]"
              >
                {f.cta} <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeatureCards;
